import { render, staticRenderFns } from "./EtapaDocumentos.vue?vue&type=template&id=bd8bdaf8"
import script from "./EtapaDocumentos.vue?vue&type=script&lang=js"
export * from "./EtapaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./EtapaDocumentos.vue?vue&type=style&index=0&id=bd8bdaf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports